module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraBold.544fa4f2.ttf";